import styled from "@emotion/styled";

export const Heading = styled.div`
  font-family: Roboto, sans-serif;
  margin: 0;
  padding: 0;
`;
